export var getUniqueFamilyIds = function (products) {
    return products
        .map(function (x) { return x.familyId; })
        .filter(function (x, index, array) { return array.indexOf(x) === index; });
};
